import * as types from "./types/app.types";

export function handleShowErrorModal() {
    return function (dispatch) {
        dispatch({ type: types.SHOW_ERROR_MODAL });
    };
}

export function handleShowExpiredModal() {
    return function (dispatch) {
        dispatch({ type: types.SHOW_EXPIRED_MODAL });
    };
}

export function handleShowRetryModal() {
    return function (dispatch) {
        dispatch({ type: types.SHOW_RETRY_MODAL });
    };
}

export function handleHideErrorModal() {
    return function (dispatch) {
        dispatch({ type: types.HIDE_ERROR_MODAL });
    };
}

export function handleHideExpiredModal() {
    return function (dispatch) {
        dispatch({ type: types.HIDE_EXPIRED_MODAL });
    };
}

export function handleHideRetryModal() {
    return function (dispatch) {
        dispatch({ type: types.HIDE_RETRY_MODAL });
    };
}
